import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Landing from "./pages/Landing";
import HealthCheck from "./pages/HealthCheck";
import Disclaimer from "./pages/Disclaimer";
import Embed from "./pages/Embed";
import EmbedTest from "./pages/EmbedTest";
import IframeTest from "./pages/IframeTest";
import "./App.css";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/health-check" element={<HealthCheck />} />
                    <Route path="/disclaimer" element={<Disclaimer />} />
                    <Route path="/embed" element={<Embed />} />
                    <Route path="/embed-test" element={<EmbedTest />} />
                    <Route path="/iframe-test" element={<IframeTest />} />
                    {/* Legacy .html paths — static-CDN mirrors swallow the
                        raw HTML files via SPA fallback, so redirect them to
                        the React equivalents. */}
                    <Route
                        path="/embed-test.html"
                        element={<Navigate to="/embed-test" replace />}
                    />
                    <Route
                        path="/iframe-test.html"
                        element={<Navigate to="/iframe-test" replace />}
                    />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-center"
                richColors
                closeButton
                toastOptions={{
                    style: {
                        fontFamily: '"DM Sans", ui-sans-serif, system-ui, sans-serif',
                    },
                }}
            />
        </div>
    );
}

export default App;
